import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-envelope-button',
  templateUrl: './envelope-button.component.html',
  styleUrls: ['../ad-actions-dialog.component.scss', '../chrome-extension.ad-actions-dialog.component.scss', 'envelope-button.component.scss'],
  standalone: false,
})
export class EnvelopeButtonComponent {
  @Input() title!: string;
  @Input() description!: string;
  @Input() tooltip!: string;
  @Input() invalidTooltip!: string;
  @Input() icon = 'drafts';
  @Input() disabled = false;
  @Input() renderMode = 'web-app';
  @Input() validConfig = true;
  @Input() buttonClass = '';
  @Input() id!: string;
  @Input() twoButtons: boolean;

  @Output() clicked = new EventEmitter<void>();

  onClick(): void {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }
}
